/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DistributedRewardSubject,
    DistributedRewardSubjectFromJSON,
    DistributedRewardSubjectFromJSONTyped,
    DistributedRewardSubjectToJSON,
    NotificationMetadata,
    NotificationMetadataFromJSON,
    NotificationMetadataFromJSONTyped,
    NotificationMetadataToJSON,
    RewardType,
    RewardTypeFromJSON,
    RewardTypeFromJSONTyped,
    RewardTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface DistributedRewardResponse
 */
export interface DistributedRewardResponse {
    /**
     * 
     * @type {string}
     * @memberof DistributedRewardResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DistributedRewardResponse
     */
    rewardConfigId: string;
    /**
     * 
     * @type {number}
     * @memberof DistributedRewardResponse
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof DistributedRewardResponse
     */
    userId: string;
    /**
     * 
     * @type {DistributedRewardSubject}
     * @memberof DistributedRewardResponse
     */
    subject: DistributedRewardSubject;
    /**
     * 
     * @type {boolean}
     * @memberof DistributedRewardResponse
     */
    webNotificationDismissed: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DistributedRewardResponse
     */
    devourPlayNotificationDismissed: boolean;
    /**
     * 
     * @type {RewardType}
     * @memberof DistributedRewardResponse
     */
    type?: RewardType;
    /**
     * 
     * @type {string}
     * @memberof DistributedRewardResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof DistributedRewardResponse
     */
    description?: string;
    /**
     * 
     * @type {NotificationMetadata}
     * @memberof DistributedRewardResponse
     */
    notificationMetadata?: NotificationMetadata;
    /**
     * 
     * @type {string}
     * @memberof DistributedRewardResponse
     */
    promoTokenId?: string;
    /**
     * 
     * @type {string}
     * @memberof DistributedRewardResponse
     */
    couponCode?: string;
    /**
     * 
     * @type {string}
     * @memberof DistributedRewardResponse
     */
    targetUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof DistributedRewardResponse
     */
    qrImageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof DistributedRewardResponse
     */
    updatedAt?: number;
    /**
     * 
     * @type {number}
     * @memberof DistributedRewardResponse
     */
    createdAt?: number;
}

export function DistributedRewardResponseFromJSON(json: any): DistributedRewardResponse {
    return DistributedRewardResponseFromJSONTyped(json, false);
}

export function DistributedRewardResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DistributedRewardResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'rewardConfigId': json['rewardConfigId'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'userId': json['userId'],
        'subject': DistributedRewardSubjectFromJSON(json['subject']),
        'webNotificationDismissed': json['webNotificationDismissed'],
        'devourPlayNotificationDismissed': json['devourPlayNotificationDismissed'],
        'type': !exists(json, 'type') ? undefined : RewardTypeFromJSON(json['type']),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'notificationMetadata': !exists(json, 'notificationMetadata') ? undefined : NotificationMetadataFromJSON(json['notificationMetadata']),
        'promoTokenId': !exists(json, 'promoTokenId') ? undefined : json['promoTokenId'],
        'couponCode': !exists(json, 'couponCode') ? undefined : json['couponCode'],
        'targetUrl': !exists(json, 'targetUrl') ? undefined : json['targetUrl'],
        'qrImageUrl': !exists(json, 'qrImageUrl') ? undefined : json['qrImageUrl'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
        'createdAt': !exists(json, 'createdAt') ? undefined : json['createdAt'],
    };
}

export function DistributedRewardResponseToJSON(value?: DistributedRewardResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'rewardConfigId': value.rewardConfigId,
        'amount': value.amount,
        'userId': value.userId,
        'subject': DistributedRewardSubjectToJSON(value.subject),
        'webNotificationDismissed': value.webNotificationDismissed,
        'devourPlayNotificationDismissed': value.devourPlayNotificationDismissed,
        'type': RewardTypeToJSON(value.type),
        'name': value.name,
        'description': value.description,
        'notificationMetadata': NotificationMetadataToJSON(value.notificationMetadata),
        'promoTokenId': value.promoTokenId,
        'couponCode': value.couponCode,
        'targetUrl': value.targetUrl,
        'qrImageUrl': value.qrImageUrl,
        'updatedAt': value.updatedAt,
        'createdAt': value.createdAt,
    };
}


